import { Component } from '@angular/core';
@Component({
    selector: 'page-claveunica-token',
    templateUrl: './claveunica_token.component.html'
})


export class ClaveUnicaTokenComponent {
    public token;
    constructor(){

    }
}